<template>
  <div>
    <div class="maintenance">
      <div class="servicingtime">
          <div class="definitetime">{{echarts11Data.servicingtime}}<span class="h">h</span></div>
          <div class="averagetime">平均维修时间</div>
      </div>
      <div class="servicing">
        <div class="quantity">
          <div class="bgs">
           {{echarts11Data.quantity}}
          </div>
          <div class="msg">
            维修数量
            <div>(台)</div>
          </div>
        </div>
        <div class="quantity">
          <div class="bgs">{{echarts11Data.maintain}}</div>
          <div class="msg">
            维修数量
            <div>(台)</div>
          </div>
        </div>
        <div class="quantity">
          <div class="bgs">{{echarts11Data.quality}}</div>
          <div class="msg">
            维修数量
            <div>(台)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts11",
  props: {
    echarts11Data: {
      type: Object,
      default: () => {
        return {
          servicingtime: "666",
          quantity: "30",
          maintain: "44",
          quality: "10"
        };
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.maintenance {
  width: 337px;
  height: 230px;
  position: relative;
  margin: 0 auto;
}
.servicingtime {
  width: 175px;
  height: 184px;
  background: url("../../assets/img/echarts09big.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
  left: 10px;
}
.servicing {
  width: 115px;
  height: 184px;
  position: absolute;
  right: 5px;
  bottom: 0;
}
.quantity {
  width: 100%;
  height: 51px;
  margin-top: 8px;
  display: flex;
}
.bgs {
  width: 50px;
  height: 51px;
  background: url("../../assets/img/echarts09s.png") no-repeat;
  text-align: center;
   font-size: 18px;
  color: #e1b523;
  line-height: 51px;
}
.msg {
  width: 60px;
  height: 51px;
  margin-left: 5px;
  font-size: 14px;
  margin-top: 10px;
  color: #978550;
}
.definitetime {
    color: #e1b523;
    font-size: 20px;
    position: absolute;
    top: 70px;
    left: 66px
}
.averagetime {
     color: #fff;
     font-size: 12px;
     width: 50px;
     position: absolute;
     top: 90px;
     left: 62px;
     text-align: center;
}
.h {
    font-size: 16px
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts1.vue